import { OfferLegalInfoList } from './../../interfaces/cart-details.interface';
import { Component, Input } from '@angular/core';
import { hiddenElementSlideInOut } from '../animations/slides.animation';
import { OfferLegalInfoListPositionEnum } from '../../models/offer-legal-info-list-position.enum';

type OfferLegals = {
  mainLegals: string[];
  legals?: string[];
};

@Component({
  selector: 'legal',
  templateUrl: './legal.component.html',
  animations: [hiddenElementSlideInOut]
})

export class LegalComponent {
  @Input() set slot(slot) {
    this.isSlot = true;
    this.translateTooltip = slot.translateTooltip;
    this.isInstallmentsOldPrice = slot.newContractPrices?.installments?.length && slot.newContractPrices?.installments[0]?.oldPrice;
    this.isSubscriptionOldPrice = slot.newContractPrices?.summaryPrice?.length && slot.newContractPrices?.summaryPrice[0]?.oldPrice;
    this.offerLegalInfo = slot.getOfferLegalInfo();
  }

  @Input() set accessory(accessory) {
    this.isSlot = false;
    this.isAccessoryOldPrice = accessory.oldPrice;
    this.offerLegalInfo = accessory.offerLegalInfoList;
  }

  private isInstallmentsOldPrice: boolean;
  private isSubscriptionOldPrice: boolean;
  public opened: boolean;
  public offerLegalInfo: OfferLegalInfoList[];
  public translateTooltip: boolean;
  private isAccessoryOldPrice: boolean;
  private isSlot: boolean;

  constructor() {}

  offerLegals(): OfferLegals | undefined {
    const legals: string[] = [];
    const mainLegals: string[] = [];
    let isShowLegal: boolean;

    this.offerLegalInfo?.forEach(legal => {
      isShowLegal = !legal.legalInfo
        || legal.position === OfferLegalInfoListPositionEnum.SUBSCRIPTION
          && ((this.isSlot && !this.isSubscriptionOldPrice) || (!this.isSlot && !this.isAccessoryOldPrice))
        || legal.position === OfferLegalInfoListPositionEnum.INSTALLMENT && !this.isInstallmentsOldPrice;
    });

    if (isShowLegal) {
      return { mainLegals };
    }

    const wantedLegalIdx = this.offerLegalInfo.findIndex(legal => legal.legalInfo?.includes('\n'));

    if (wantedLegalIdx > -1 && this.offerLegalInfo[wantedLegalIdx]?.legalInfo) {
      const splitLegal = this.offerLegalInfo[wantedLegalIdx].legalInfo?.split('\n');

      if (splitLegal) {
        mainLegals.push(splitLegal[0]);
        legals.push(splitLegal[1]);
      }
    }

    this.offerLegalInfo.forEach((legal, index) => {
      if (!legal.legalInfo || index === wantedLegalIdx) return;

      (legals.length ? legals : mainLegals).push(legal.legalInfo);
    });

    return legals?.length ? { mainLegals, legals } : { mainLegals };
  }
}
